/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Subtitle1Inputs */

const vi_sitesettings_subtitle1 = /** @type {(inputs: Sitesettings_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chữ quảng bá, liên kết, SEO của website và Zalo Mini App. Ô để trống thì web / Mini App dùng chữ mặc định trong code.`)
};

/**

* @param {Sitesettings_Subtitle1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_subtitle1 = /** @type {((inputs?: Sitesettings_Subtitle1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Subtitle1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_subtitle1(inputs)
});
export { sitesettings_subtitle1 as "siteSettings_subtitle" }